module.exports = __webpack_public_path__ + "img/close.ffb0735d.svg";